// lib/idiomas.js
// Idiomas del sitio, en una sola lista.
//
// Un idioma nuevo entra primero en OCULTOS: todo el código lo conoce (normalizadores,
// metadatos, textos, ids de producto), pero el ruteo (proxy), el selector de idioma,
// el sitemap y el hreflang no lo exponen hasta que pasa a PUBLICOS. Ver
// RUNBOOK-AGREGAR-IDIOMA.md.
//
// - PUBLICOS: los que se ven, en el orden del selector (japonés al final: Fede, 6-oct-2026).
// - TODOS: para VALIDAR ("este idioma lo entiendo"). Nunca para exponer.
// - VISIBLES: para EXPONER (proxy, selector, sitemap, hreflang, generateStaticParams).
//   En local, NEXT_PUBLIC_IDIOMAS_OCULTOS_VISIBLES=1 muestra también los ocultos.
//
// Sin fs ni nada de Node: lo importa el proxy.

export const PUBLICOS = ['es', 'en', 'pt', 'fr', 'it', 'de', 'tr', 'ja']
export const OCULTOS = []
export const TODOS = [...PUBLICOS, ...OCULTOS]

// NEXT_PUBLIC_ se reemplaza en el build: el cliente y el servidor ven lo mismo.
export const OCULTOS_VISIBLES = process.env.NEXT_PUBLIC_IDIOMAS_OCULTOS_VISIBLES === '1'
export const VISIBLES = OCULTOS_VISIBLES ? TODOS : PUBLICOS

export const esIdioma = (ln) => !!ln && TODOS.includes(ln)
export const esVisible = (ln) => !!ln && VISIBLES.includes(ln)
